import {
  BackButton,
  Container,
  LoadingIndicator,
  Page,
  PageTitle,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { useOrganization } from '@foxtrotplatform/platform-micro-site-core';
import { Button } from '@windmill/react-ui';
import { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';

import {
  SolutionInputFields,
  SolutionVersionDTO,
} from '../../common/api/models/solution';
import { fetchSolution } from '../../common/api/solution';
import { getLatestSolutionVersion } from './getLatestSolutionVersion';
import { SolutionRegistrationInput } from './SolutionRegistrationInput';
import { solutionTabs } from './solutionSteps';
import { SolutionSubmissionTabs } from './SolutionSubmissionTabs';

export const SolutionSummary: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const { currentOrg } = useOrganization();
  const { solutionId } = useParams();
  const [newestSolution, setNewestSolution] = useState<SolutionVersionDTO>();

  useEffect(() => {
    if (!currentOrg || !solutionId) {
      return;
    }

    const executeQuery = async () => {
      const solution = await fetchSolution(currentOrg.id, solutionId);

      setNewestSolution(getLatestSolutionVersion(solution.versions));
    };
    executeQuery();
  }, [solutionId]);

  const { register, reset, control, formState } = useForm<SolutionInputFields>({
    defaultValues: useMemo(() => {
      return newestSolution;
    }, [newestSolution]),
    mode: 'onBlur',
  });

  useEffect(() => {
    reset(newestSolution);
  }, [newestSolution]);

  const onSubmit = () => {
    navigate(`/solution/${solutionId}/edit`);
  };

  if (!newestSolution) {
    return (
      <Page>
        <Container>
          <div className="w-full flex flex-row p-6 justify-center">
            <LoadingIndicator />
          </div>
        </Container>
      </Page>
    );
  }

  return (
    <Page>
      <Container size="medium">
        <div className="w-full flex flex-col justify-between items-center mb-os1-spacing">
          <div className="w-full flex flex-row items-center gap-x-3">
            <BackButton />
            <PageTitle>{newestSolution.displayName}</PageTitle>
          </div>
          <div className="w-full mt-6">
            <SolutionSubmissionTabs
              activeTab="register"
              disabled={['define', 'artifacts']}
              tabs={solutionTabs}
            />
          </div>
        </div>
        <div>
          <form onSubmit={onSubmit}>
            <SolutionRegistrationInput
              control={control}
              disabled={true}
              formState={formState}
              register={register}
            />
            <div className="w-full flex flex-row p-4 bg-gray-100">
              <Button layout="outline" type="submit">
                Edit
              </Button>
            </div>
          </form>
        </div>
      </Container>
    </Page>
  );
};
